var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.3929 28.626C56.3929 42.7677 45.9133 54.459 32.2994 56.3562C31.0265 56.5328 29.7241 56.625 28.4022 56.625C26.8762 56.625 25.3777 56.5034 23.9185 56.2679C10.589 54.1215 0.409424 42.5617 0.409424 28.626C0.409424 13.1619 12.9426 0.625 28.4002 0.625C43.8578 0.625 56.3929 13.1619 56.3929 28.626Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2994 23.1071V29.2068H39.8428L38.6483 37.4235H32.2994V56.3543C31.0264 56.5309 29.7241 56.6231 28.4021 56.6231C26.8762 56.6231 25.3777 56.5015 23.9184 56.266V37.4235H16.9614V29.2068H23.9184V21.7435C23.9184 17.1133 27.6705 13.3582 32.3013 13.3582V13.3621C32.3151 13.3621 32.3268 13.3582 32.3406 13.3582H39.8448V20.4643H34.9413C33.484 20.4643 32.3013 21.6474 32.3013 23.1051L32.2994 23.1071Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.b7ba7057854f95d72ef7ede926762ec3.svg";
export { ForwardRef as ReactComponent };